/**
 * Created by karora on 13/03/17.
 */

export class IssueActionType {
  action_type_id: number;
  action_type_text: string;

  // 'Internal'), ('EMail'), ('Call'), ('Social Media'), ('Site Visit'), ('Reopen'), ('Escalate'), ('Defer'), ('Resolve'), ('Other');
  static Other = 1;
  static Escalate = 7;
  static Defer = 8;
  static Resolve = 9;
  static ResolveDuplicate = 11;
}
